import type { DefinitionsCatalogBody, VisualizationTypesCatalogBody } from '../models/catalog.types'

import { appHttp, unwrap } from '@/shared/http'

/**
 * Legacy catalog sources for the two entries module 08 consumes (contract 08 §6.1).
 *
 * The versioned `/catalog/` transport itself lives in `shared/catalog` — the manifest is one
 * cross-feature singleton. What stays here are the byte-identical legacy endpoints used on a
 * cold miss: a session-only fallback, never a second steady-state source, and never cached (no
 * version accompanies these bodies).
 */
export class CatalogApi {
  constructor(private readonly app: Pick<typeof appHttp, 'get'> = appHttp) {}

  /** Catalog reads own their degraded UX (a degraded label fallback), never a toast. */
  private config() {
    return {
      suppressGlobalErrorHandler: true,
      meta: { suppressGlobalErrorHandler: true },
    }
  }

  async fetchDefinitionsLegacy(): Promise<DefinitionsCatalogBody> {
    return unwrap(await this.app.get<DefinitionsCatalogBody>('/definitions/all/', this.config()))
  }

  async fetchVisualizationTypesLegacy(): Promise<VisualizationTypesCatalogBody> {
    return unwrap(
      await this.app.get<VisualizationTypesCatalogBody>(
        '/custom-dashboard/visualization-types/',
        this.config(),
      ),
    )
  }
}

export const catalogApi = new CatalogApi()
